/* eslint-disable camelcase */
import { Text } from '@nike/eds';
import { addDays } from 'date-fns';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect } from 'react';
import './npos.css';
import { useDispatch, useSelector } from 'react-redux';

import { setNposValue } from '../../../redux/actions';
import { getBodyTranslations, getCurrentStore, getNposValue } from '../../../redux/selectors';
import { NPOS } from '../../../utils/constants';
import { ButtonWhite } from '../../reusable';

import { convertDateToTimezone } from './filters/DateRangePicker/dateUtils';
import NposFilters from './NposFilters';

function NposHeader({
 onSubmit, isLoading, selectStore, selectCountry, handleChange, timezone, onClear, onUiToggle, isReadyForAutoFetch, fields, storeLocale
}) {
  const dispatch = useDispatch();
  const { doInitialLoad, switchUiAvailable, showNewUi } = useSelector(getNposValue);
  const currentStore = useSelector(getCurrentStore);
  const { RL_ElectronicJournal } = useSelector(getBodyTranslations);

  const loadLatestTransactions = useCallback(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const convertedDate = convertDateToTimezone({
      endDate: addDays(today, 0),
      key: 'selection',
      startDate: addDays(today, -1),
    }, { from: NPOS.DAY_START_TIME, to: NPOS.DAY_END_TIME }, timezone, moment);

    handleChange('selectedDates', convertedDate);

    const setDoInitalLoad = (value) => dispatch(setNposValue({ doInitialLoad: value }));

    onSubmit();
    setDoInitalLoad(false);
    dispatch(setNposValue({ isHomePage: true }));
  }, [onSubmit, dispatch, handleChange, timezone]);

  useEffect(() => {
    if (currentStore && currentStore.value && doInitialLoad && isReadyForAutoFetch) {
      loadLatestTransactions();
    }
  }, [currentStore, doInitialLoad, loadLatestTransactions, dispatch, handleChange, timezone, isReadyForAutoFetch]);

  return (
    <div>
      <div className="d-sm-flx flx-ai-sm-c flx-jc-sm-sb" data-testid="npos-header">
        <Text className="ta-sm-l title" data-testid="npos-ej-title">
          {RL_ElectronicJournal}
        </Text>
        {showNewUi && switchUiAvailable && (
          <ButtonWhite
            className={`rightAlign mt3-sm ${isLoading ? 'hidden' : ''}`}
            label="Switch to Old UI"
            onClick={onUiToggle}
          />
        )}
      </div>
      <NposFilters
        fields={fields}
        handleChange={handleChange}
        isLoading={isLoading}
        loadLatestTransactions={loadLatestTransactions}
        selectCountry={selectCountry}
        selectStore={selectStore}
        storeLocale={storeLocale}
        timezone={timezone}
        onClear={onClear}
        onSubmit={onSubmit}
      />
    </div>
  );
}

NposHeader.propTypes = {
  fields: PropTypes.shape().isRequired,
  handleChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isReadyForAutoFetch: PropTypes.bool.isRequired,
  onClear: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onUiToggle: PropTypes.func.isRequired,
  selectCountry: PropTypes.func.isRequired,
  selectStore: PropTypes.func.isRequired,
  storeLocale: PropTypes.string.isRequired,
  timezone: PropTypes.string.isRequired,
};

export default NposHeader;
